/**
 * <sunday-open>: "Open now · until 7 pm" or "Opens at 10 am · until 7 pm" from the store's hours
 * text ("10 am to 7 pm"), in India time. Words come from the block; the dot turns green when open.
 */
const IST_OFFSET = 330; // minutes ahead of UTC

function parse(t) {
  const m = /(\d{1,2})(?::(\d{2}))?\s*(am|pm)?/i.exec(t || '');
  if (!m) return null;
  let h = Number(m[1]) % 12;
  if (m[3] && /pm/i.test(m[3])) h += 12;
  const label = m[3] ? `${m[1]}${m[2] ? ':' + m[2] : ''} ${m[3].toLowerCase()}` : `${m[1]}${m[2] ? ':' + m[2] : ''}`;
  return { min: h * 60 + Number(m[2] || 0), label, ampm: !!m[3] };
}

// 24 Oct: language pages translate the hours ("सुबह 10 से शाम 7 बजे तक"), so read the first two times in
// the text; without am/pm, a closing hour at or before the opening hour is in the afternoon (10 … 7 = 7 pm).
function hours(text) {
  const s = String(text || '');
  const re = /(\d{1,2})(?::(\d{2}))?\s*(am|pm)?/gi;
  const found = [];
  let m;
  while ((m = re.exec(s)) && found.length < 2) found.push(parse(m[0]));
  if (found.length < 2) return null;
  const [a, b] = found;
  if (!b.ampm && b.min <= a.min) b.min += 720;
  return [a, b];
}

class SundayOpen extends HTMLElement {
  connectedCallback() {
    const hb = hours(this.dataset.hours);
    if (!hb) return;
    const [a, b] = hb;
    const now = new Date();
    const ist = (now.getUTCHours() * 60 + now.getUTCMinutes() + IST_OFFSET) % 1440;
    const open = ist >= a.min && ist < b.min;
    const text = (open ? this.dataset.open : this.dataset.opens) || '';
    this.querySelector('span').textContent = text.replace('[open]', a.label).replace('[close]', b.label);
    this.toggleAttribute('data-now', open);
  }
}
if (!customElements.get('sunday-open')) customElements.define('sunday-open', SundayOpen);
